import React from 'react';
import CategoryModal from '../components/CategoryModal';

function Main({ onSelect, onClose, initialSelectedCategoryId, initialSelectedSubcategoryId }) {
  return (
    <div className="fixed inset-0 z-[1000] flex">
      {/* Left sliding panel */}
      <div className="h-full w-full max-w-[900px] md:max-w-[40%] bg-[var(--secondary-color)] md:bg-white shadow-2xl rounded-none md:rounded-r-[10px] overflow-y-auto">
        <CategoryModal
          onSelect={onSelect}
          onClose={onClose}
          initialSelectedCategoryId={initialSelectedCategoryId}
          initialSelectedSubcategoryId={initialSelectedSubcategoryId}
        />
      </div>
      {/* Dark overlay on the right side */}
      <div
        className="flex-1 bg-[#00000089] cursor-pointer"
        onClick={onClose}
      />
    </div>
  );
}

export default Main;